<template>
  <div class="noticias">
    <Header bg />
    <div class="page-title-holder no-print">
      <TituloPagina />
    </div>

    <div class="conteudo-materias print-only">
      <div class="materias">
        <router-view></router-view>
      </div>
      <div class="conteudo-lateral">

        <BarraLateral class="no-print" :ativo="statusBarraLateral" />
  
      </div>
    </div>
    
    <div class="main-footer-holder">
      <FaleConosco/>
      <MainFooter />
    </div>
    <BotaoVoltarTopo class="no-print" />
  </div>
</template>

<script>
import Header from '@/components/layout/header/Header.vue';
import BarraLateral from '@/components/layout/conteudo/BarraLateral.vue';
import TituloPagina from '@/components/layout/conteudo/TituloPagina.vue';
import MainFooter from '@/components/layout/footer/MainFooter.vue';
import BotaoVoltarTopo from '@/components/BotaoVoltarTopo.vue';
import mixins from '@/helpers/mixins';
import FaleConosco from '@/components/layout/conteudo/FaleConosco.vue';

export default {
  name: 'noticias',
  mixins: [mixins],
  components: {
    Header,
    BarraLateral,
    MainFooter,
    BotaoVoltarTopo,
    TituloPagina,
    FaleConosco,
  },
  data() {
    return {
      routeName: this.$router.currentRoute.name,
    };
  },
  methods: {
    voltarAoTopo() {
      window.scrollTo({ top: 0 });
    },
  },
  computed: {
    statusBarraLateral() {
      const status = name => {
        switch (name) {
          case 'post':
            return true;
          case 'se-liga':
            return true;
          case 'ranking-lojas':
            return true;
          default:
            return false;
        }
      };
      return !status(this.routeName);
    },
  },
  watch: {
    $route(after) {
      this.routeName = after.name;
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/estilo/sass/_formulas.scss';
@import '@/estilo/sass/_cores.scss';



$largura-foto-grande: 290px;
$altura-foto-grande: 185px;

.page-title-holder {
  @extend %flex;
  @extend %align-items-end;
  height: 130px;
  background-color: white;
  -webkit-box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
  box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
}

.conteudo-materias {
  @extend %flex;
  @extend %direction-row;
  @extend %justify-between;
  // @extend %area-de-utilizacao;
  margin: 0 auto;
  margin-top: 50px;
  min-height: calc(100vh - 482px);

  & .materias {
    @extend %flex;
    @extend %direction-row;
    @extend %justify-between;
    @extend %flex-wrap;
    width: 980px;
    height: 100%;
    box-sizing: border-box;
    padding: 0px;
    margin: 0 auto;
    @media print {
      width: 100% !important;
    }
  }

  & .conteudo-lateral {
    display: flex;
    flex-direction: column;
    gap: 20px;
  }
}

.main-footer-holder {
  padding: 40px 0px 0px;
  margin-top: 30px;
}

// .page-title-holder {
//   @extend %flex;
//   @extend %align-items-end;
//   height: 140px;
//   background-color: white;
//   -webkit-box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
//   -moz-box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);
//   box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.15);

// }

// .conteudo-materias {
//   @extend %flex;
//   @extend %direction-row;
//   @extend %justify-between;
//   @extend %area-de-utilizacao;
//   margin: 0 auto;
//   margin-top: 50px;
//   min-height: calc(100vh - 482px);

//   & .materias {
//     @extend %flex;
//     @extend %direction-row;
//     @extend %justify-between;
//     @extend %flex-wrap;
//     width: 600px;
//     height: 100%;
//     box-sizing: border-box;
//     padding: 0px;
//     margin: 0 auto;
//   }
// }

// .main-footer-holder {
//   padding: 40px 0px 0px;
//   margin-top: 30px;
// }

@media all and (min-width: 300px) and (max-width: 679px) {
  .page-title-holder {
    height: 105px;
  }

  .conteudo-materias {
    flex-direction: column !important;
    margin: 0 auto;
    margin-top: 30px;
    min-height: calc(100vh - 287px);

    & .materias {
      max-width: 80vw;
    }
  }

  .main-footer-holder {
    padding: 0px 0px 0px;
    margin-top: 0px;
  }
}

@media all and (min-width: 680px) and (max-width: 1000px) {
  .page-title-holder {
    height: 135px;
  }

  .conteudo-materias {
    min-height: calc(100vh - 288px);
  }
}
</style>
